define.alias("ember-power-select/components/power-select-multiple/input", "media/components/power-select-multiple/input");